import Immutable from 'seamless-immutable';
import SmartUrlModel from './smart-url-model';
import { baseCollection } from '../../common/collections';

/**
 * Transforms and array of backend smartUrl objects into a SmartUrlCollection
 * @param {Object[]} smartUrls - backend formatted smartUrls
 * @returns {SmartUrl[]}
 */
function deserialize(smartUrls = []) {
  return Immutable(_.map(smartUrls, SmartUrlModel.deserialize));
}

/**
 * Transforms a SmartURLCollection into an array of backend smartUrl objects
 * @param {SmartUrl[]} smartUrls
 * @returns {Object[]}
 */
function serialize(smartUrls) {
  return _.map(smartUrls, smartUrl => SmartUrlModel.serialize(smartUrl));
}

export default {
  ...baseCollection,
  create: deserialize,
  deserialize,
  serialize,
};
